import React, { useState } from 'react'

import { TemporalCondition } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { ButtonGroup } from '@avantstay/backoffice-core'

import { getDateTypeOptions } from '@new/__global/components/DatePickerCustomFilter/DatePickerCustomFilter.utils'

import * as S from './DatePickerCustomFilter.styles'

interface DatePickerCustomFilterProps {
  periodReferenceOption?: TemporalCondition
  onChangeOption: (value?: TemporalCondition) => void
}

export const DatePickerCustomFilter = ({
  periodReferenceOption,
  onChangeOption,
}: DatePickerCustomFilterProps) => {
  const [localValue, setLocalValue] = useState<TemporalCondition | undefined>(periodReferenceOption)

  const dateTypeOptions = getDateTypeOptions()

  const handleOnChange = (value?: TemporalCondition) => {
    setLocalValue(value)
    onChangeOption(value)
  }

  return (
    <S.Container>
      <ButtonGroup
        currentSelection={localValue}
        name="date-picker-custom-filter-select"
        onClick={handleOnChange}
        options={dateTypeOptions}
      />
    </S.Container>
  )
}
